
import { IKeHoachMonGhepCapSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonGhepCapSelectRequest";
import { IKeHoachMonSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectRequest";
import { IKeHoachMonGhepCap } from "../../../model/respone/ke-hoach/IKeHoachMonGhepCap";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { IKeHoachMonGhepCapFilterReducer } from "../../reducer-model/ke-hoach/IKeHoachMonGhepCapReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachMonGhepCapActionsObj = {
    LOAD_START: {} as IKeHoachMonGhepCapSelectRequest,
    LOAD_SUCCESS: {} as IKeHoachMonGhepCap[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IKeHoachMonGhepCap | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IKeHoachMonGhepCap[],
    SAVE_SUCCESS: {} as IKeHoachMonGhepCap[],
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_FILTER: {} as IKeHoachMonGhepCapFilterReducer,

    LOAD_KE_HOACH_MON_START: {} as IKeHoachMonSelectRequest,
    LOAD_KE_HOACH_MON_SUCCESS: {} as IKeHoachMonViewModel[],
    LOAD_KE_HOACH_MON_ERROR: "",

    CHANGE_EXPANDED_IDS: {} as number[]

};
export const eKeHoachMonGhepCapActionIds = generateActionTypeIds(
    eKeHoachMonGhepCapActionsObj,
    "GHEP_CAP"
);
export type IKeHoachMonGhepCapActionTypes = IGenericActionType<
    typeof eKeHoachMonGhepCapActionsObj,
    "GHEP_CAP"
>;
